import React, { useState, useEffect, useContext } from 'react';
import {
	Select,
	MenuItem,
	FormControl,
	InputLabel,
	Button,
	Stack,
	TextField,
	Box,
	Typography
} from '@mui/material';
import { DataContext } from '../../../../context/DataContext';
import { getToken } from '../../../../api/Account';
import { getSucursalByUserAsync } from '../../../../api/Users';
import { getUsuariosCampoAsync } from '../../../../api/Positions';
import { getRuta, simpleMessage } from '../../../../helpers/Helpers';
import { faRoute } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import moment from 'moment/moment';
import { accionPrincipalSx } from '../../../../components/ui/accionPrincipal';

const SelectorRutaCobro = () => {
	const [gestorList, setGestorList] = useState([]);
	const [selectedGestor, setSelectedGestor] = useState('');
	const [selectedFecha, setSelectedFecha] = useState(new Date());

	const [sucursalList, setSucursalList] = useState([]);
	const [selectedSucursal, setSelectedSucursal] = useState('t');

	const { setIsLoading, setIsUnautorized } = useContext(DataContext);
	let ruta = getRuta();
	const token = getToken();

	useEffect(() => {
		getGestores(selectedSucursal);
		getSucursals();
	}, []);

	const verReport = () => {
		if (selectedGestor === '') {
			simpleMessage('Seleccione un gestor', 'error');
			return;
		}
		if (!moment(selectedFecha).isValid()) {
			simpleMessage('Seleccione una fecha válida', 'error');
			return;
		}

		var params = `${selectedGestor}/${moment(selectedFecha).format('YYYY-MM-DD')}`;
		window.open(`${ruta}/r-rutacobro/${params}`);
	};

	const getSucursals = async () => {
		setIsLoading(true);
		const result = await getSucursalByUserAsync(token);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		setIsLoading(false);
		setSucursalList(result.data.result);
	};

	const onChangeSucursal = (value) => {
		setSelectedSucursal(value);
		setSelectedGestor('');
		getGestores(value);
	};

	const getGestores = async (sucursal) => {
		setIsLoading(true);
		const result = await getUsuariosCampoAsync(token, sucursal === 't' ? null : sucursal);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setIsLoading(false);
		setGestorList(result.data.result);
	};

	return (
		<div>
			<Box sx={{ width: '100%', maxWidth: 550 }}>
				<Stack spacing={2}>
					<Typography variant="body2" textAlign={'center'} color="text.secondary">
						Ordena los cobros del día para recorrer la menor distancia posible. Solo
						entran los clientes con ubicación conocida; los demás salen aparte en la
						misma hoja.
					</Typography>

					<FormControl fullWidth style={{ textAlign: 'left' }}>
						<InputLabel id="demo-simple-select-standard-label">Sucursal</InputLabel>
						<Select
							labelId="demo-simple-select-standard-label"
							id="demo-simple-select-standard"
							onChange={(e) => onChangeSucursal(e.target.value)}
							value={selectedSucursal}
							label="Sucursal"
						>
							{sucursalList.map((item) => {
								return (
									<MenuItem key={item.id} value={item.id}>
										{item.description}
									</MenuItem>
								);
							})}
							<MenuItem key={'t'} value={'t'}>
								TODAS...
							</MenuItem>
						</Select>
					</FormControl>

					<FormControl fullWidth style={{ textAlign: 'left', marginTop: 20 }}>
						<InputLabel id="demo-simple-select-standard-label">Gestor</InputLabel>
						<Select
							labelId="demo-simple-select-standard-label"
							id="demo-simple-select-standard"
							onChange={(e) => setSelectedGestor(e.target.value)}
							value={selectedGestor}
							label="Gestor"
							style={{ textAlign: 'left' }}
						>
							<MenuItem value="">
								<em>Seleccione un gestor</em>
							</MenuItem>
							{gestorList.map((item) => {
								return (
									<MenuItem key={item.id} value={item.id}>
										{item.rolName ? `${item.fullName} · ${item.rolName}` : item.fullName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>

					<DesktopDatePicker
						closeOnSelect
						label="Seleccione una fecha"
						inputFormat="DD/MM/YYYY"
						value={selectedFecha}
						onChange={(newValue) => setSelectedFecha(newValue)}
						renderInput={(params) => <TextField {...params} />}
					/>

					<Button
						variant="contained"
						startIcon={<FontAwesomeIcon icon={faRoute} />}
						onClick={() => verReport()}
						sx={accionPrincipalSx}
					>
						Generar Ruta
					</Button>
				</Stack>
			</Box>
		</div>
	);
};

export default SelectorRutaCobro;
